import { cn } from "@/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export type RailZeroStateAccent = "rust" | "sage" | "teal" | "plum";

export interface RailZeroStateAction {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  icon?: LucideIcon;
}

export interface RailZeroStateProps {
  icon?: LucideIcon;
  accent?: RailZeroStateAccent;
  title: string;
  description: string;
  variant?: "cta" | "passive";
  action?: RailZeroStateAction;
  /** Kept for call-site compatibility; the quiet register renders no CTA. */
  actionSlot?: ReactNode;
  className?: string;
}

/**
 * Rail empty state — the design system's quiet register: one muted line,
 * no icon well, no card chrome, and deliberately NO call-to-action (the
 * create verbs live in the rail head and section controls; an empty list
 * never duplicates them). Legacy props (icon, accent, variant, action) are
 * accepted and ignored so historical call sites keep compiling while every
 * surface converges on the quiet line.
 */
export function RailZeroState({
  title,
  description,
  className,
}: RailZeroStateProps) {
  return (
    <p className={cn("px-2 py-3 text-sm text-n-40", className)}>
      {title} {description}
    </p>
  );
}
